import { Lock } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { allowed } from "../../lib/adminApi";

export const PageHeader = ({ eyebrow, title, children }) => (
  <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
    <div>
      {eyebrow && <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#C59B27]">{eyebrow}</p>}
      <h1 className="mt-1 font-display text-3xl font-bold tracking-tight text-[#4A000E] sm:text-4xl">{title}</h1>
    </div>
    <div className="flex flex-wrap gap-2">{children}</div>
  </div>
);

export function Guard({ perm, children }) {
  const auth = useAuth();
  if (allowed(auth, perm)) return children;
  return (
    <div data-testid="no-permission" className="rmm-card flex items-center gap-3 p-8 text-sm text-[#8C6A6C]">
      <Lock className="h-5 w-5 text-[#7A0016]" /> You do not have permission to view this page.
    </div>
  );
}
